<template>
  <div class="info-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary"><router-link to="/news/add_news">添加资讯</router-link></el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              :data="tableData"
              :row-style="{cursor: 'pointer'}"
              stripe
              v-loading="tableLoading"
              style="width: 100%">
              <el-table-column
                label="封面图片"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.img_url"
                    fit="contain"
                    style="width: 100%;height: 40px;"
                    :preview-src-list="[scope.row.img_url]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="title"
                min-width="200"
                label="标题"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span @click="openDetails(scope.row)">{{scope.row.title}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="username"
                label="发布人"
                align="center"
                width="170">
                <template slot-scope="scope">
                  <div v-if="scope.row.username!==''">{{scope.row.username}}</div>
                  <div v-if="scope.row.username===''">Elichain</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="time"
                align="center"
                label="发布时间"
                width="150">
              </el-table-column>
              <el-table-column
                prop="views"
                label="浏览人数"
                align="center"
                width="150">
              </el-table-column>
              <el-table-column
                prop="time"
                label="操作"
                align="center"
                width="180">
                <template slot-scope="scope">
                  <el-button @click.stop="editRow(scope.row)" size="mini" icon="el-icon-edit-outline" >编辑</el-button>
                  <el-button @click.stop="deleteRow(scope.row)" size="mini" icon="el-icon-delete">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-row>
    <el-dialog
      title="编辑资讯"
      :visible.sync="dialogVisible"
      width="65%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :before-close="handleClose">
      <el-form ref="form" size="small" :model="infoData" label-width="80px" :rules="rules" style="padding:15px 30px 15px 15px;">
        <el-form-item label="标题" prop="title">
          <el-input placeholder="请输入标题" show-word-limit maxlength="100" v-model="infoData.title"/>
        </el-form-item>
        <el-form-item label="封面图片">
          <SingleImg :key="infoData.key" v-model="infoData.image" :oldurl="infoData.image.url"/>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <tinymce ref="tinymce" v-model="infoData.content" :height="200" />
        </el-form-item>
        <el-form-item>
          <el-button :loading="btnLoading" type="primary" @click="editNews('form')">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getNewsPC } from '@/api/home'
import { deleteNews } from '@/api/work'
import { updateNews } from '@/api/work'
import SingleImg from '@/components/upload/SingleImg'
import tinymce from '@/components/Tinymce'

export default {
  computed: {
    user: getUser
  },
  components: {
    SingleImg,
    tinymce
  },
  created() {
    this.getNewsData()
  },
  data() {
    return {
      btnLoading: false,
      dialogVisible: false,
      tableData: [],
      searchForm: {
        search: ''
      },
      tableLoading: false,
      infoData: {
        newsId: '',
        title: '',
        key: '',
        image: {
          id: '',
          url: ''
        },
        content: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getNewsData()
    },
    getNewsData() { // 获取资讯
      this.tableLoading = true
      const _this = this
      const data = {
        page: _this.currentPage,
        limit: _this.pageSize,
        content: _this.searchForm.search,
        status: _this.sort
      }
      getNewsPC(data).then(response => {
        _this.tableData = response.data.list
        _this.total = response.data.total
        _this.tableLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getNewsData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getNewsData()
    },
    deleteRow(row){
      if(row!=null){
        this.$confirm('您确定要删除这条资讯吗?', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          const data = {
            newsid: row.newsid
          }
          deleteNews(data).then(response=>{
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getNewsData()
          })
        }).catch(() => {
        });
      }
    },
    editRow(row){
      if(row!=null){
        this.infoData.newsId = row.newsid
        this.infoData.image.id = row.imgid
        this.infoData.image.url = row.img_url
        this.infoData.content = row.content
        this.infoData.title = row.title
      }
      this.infoData.key = new Date().getTime().toString()
      this.dialogVisible = true
    },
    editNews(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.infoData.image.imgid===''){
            this.$message({
              type: 'warning',
              message: '请选择图片'
            });
            return false
          }
        }
        this.btnLoading = true
        const data = {
          newsid: this.infoData.newsId,
          imgid: this.infoData.image.id,
          title: this.infoData.title,
          content: this.infoData.content
        }
        updateNews(data).then(response=>{
          this.$message({
            type: 'success',
            message: '修改成功'
          });
          this.dialogVisible = false
          this.btnLoading = false
          this.getNewsData()
        }).catch(() => {
          this.btnLoading = false
        });
      })
    },
    handleClose(done){
      this.infoData.newsId = ''
      this.infoData.image.id = ''
      this.infoData.image.url = ''
      this.infoData.content = ''
      this.infoData.title = ''
      done();
    },
    openDetails(row){
      this.$router.push({path:'/news/news_detail/' + row.newsid})
    }
  }
}
</script>

<style lang="scss" scoped>
.info-container {
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.tcf-row{
  .card{
    .card-body{
      .card-title{
        font-weight: 500;
        color: #404852;
        margin-bottom: 22px;
        font-size: 14px;
        .search-mode{
          width: 300px;
          position: relative;
          float: right;
          margin-top: -10px;
          .search-input{
            background-color: #F2F6FC;
            border:0;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            color: #606266;
            padding: 0 40px 0 15px;
            -webkit-appearance: none;
            font-size: 12px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            &::-webkit-input-placeholder {
              color: #C0C4CC;
            }
            &::-ms-input-placeholder {
              color: #C0C4CC;
            }
          }
          .search-btn{
            position: absolute;
            right: 0;
            height: 40px;
            width: 40px;
            line-height: 40px;
            top: 0;
            border: 0;
            background: transparent;
            text-align: center;
            padding: 0;
          }
        }
      }
      .search-area{
        float: right;
      }
      .card-content{
        .group-filter{
          width: 100%;
          padding: 0 30px 0 0 ;
          margin: 0 ;
          position: relative;
          li{
            width: 100%;
            list-style: none;
            position: relative;
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;
            cursor: pointer;
            border-radius: 2px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &.active{
              background: #f5f7fa;
              color:#409EFF;
            }
            &:hover{
              color:#409EFF;
            }
          }
        }
        .client-sex{
          width: 16px!important;
          height: 16px!important;
          vertical-align: -4px!important;
        }
        .el-table::before{
          height: 0!important;
        }
        .el-pagination{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
